import { getIconByName } from '../../utils/iconMapping';

/**
 * SelectionCard - Consistent button-style card for QuickIssue selections
 * Based on OffenceCard button pattern to ensure visual consistency
 *
 * @param {Object} item - The item being displayed (offence, value, etc)
 * @param {string} icon - Icon name to display
 * @param {string} color - Optional color for selected state
 * @param {boolean} selected - Whether item is selected
 * @param {Function} onClick - Click handler
 * @param {string} label - Text to display
 * @param {React.Node} badge - Optional badge element
 * @param {boolean} clickable - Whether button is clickable
 * @param {string} className - Additional classes
 */
export default function SelectionCard({
  item,
  icon,
  color,
  selected = false,
  onClick,
  label,
  badge,
  clickable = true,
  className = ''
}) {
  const handleClick = (e) => {
    e.stopPropagation();
    if (clickable && onClick) {
      onClick(item);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`
        inline-flex items-center gap-2 px-3 py-2 rounded-xl shadow-sm transition-all duration-200
        ${!selected && 'bg-base-100 hover:bg-base-200/50'}
        ${clickable ? 'cursor-pointer' : 'cursor-default'}
        ${className}
      `}
      style={
        selected && color
          ? {
              backgroundColor: `${color}30`,
              color: color
            }
          : {}
      }
      disabled={!clickable}
    >
      {icon && getIconByName(icon, "w-4 h-4")}
      <span className="text-sm font-medium">{label}</span>
      {badge}
    </button>
  );
}
